const ClubAchievementsCardSkeleton = () => (
  <div className="flex h-full flex-col justify-between rounded-xl border border-gray-200 bg-white p-6 shadow-sm animate-pulse">
    <header className="mb-6 flex items-start justify-between gap-4">
      <div className="min-w-0">
        <div className="h-5 w-48 rounded bg-gray-200" />
      </div>
    </header>

    <div className="flex flex-1 flex-col gap-6 md:flex-row">
      <div className="mx-auto flex h-64 w-full max-w-[280px] flex-shrink-0 items-center justify-center">
        <div className="relative h-48 w-48">
          <div className="absolute inset-0 rounded-full bg-gray-200" />
          <div className="absolute inset-6 rounded-full bg-white" />
        </div>
      </div>

      <ul className="flex flex-1 flex-col justify-center gap-3 text-sm text-gray-700">
        {[...Array(7)].map((_, index) => (
          <li key={index}>
            <div className="flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-3 py-2">
              <div className="flex flex-1 items-center gap-2">
                <div className="h-2.5 w-2.5 rounded-full bg-gray-200" />
                <div className="h-3 flex-1 rounded bg-gray-200" />
              </div>
              <div className="ml-3 h-4 w-6 rounded bg-gray-200" />
            </div>
          </li>
        ))}
      </ul>
    </div>
  </div>
)

export default ClubAchievementsCardSkeleton
